import { prop } from 'ramda'

export const time = prop('time')
export const active = prop('active')
